import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import DataTable from 'src/Components/DataTable';
import { ITest, IWellTestGroupEmail } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';
import ContractorContacts from './ContractorContactsList';
import OperatorContacts from './OperatorContactsList';
import OtherContacts from './OtherContactsList';




@inject('stores')
@observer
class ManageContacts extends React.Component {
    public props: any;
    private test: ITest = new ITest();
    public TestsStore: any;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;

    public state = {
        isDirty: false,
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;



        this.clearDisposers = this.clearDisposers.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            this.setState({
                test: this.props.stores.TestsStore.test,
                well: this.props.stores.WellsStore.well
            });
        } else {
            this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            this.WellsStore.getWellDetails(this.props.match.params.wellId);
        }
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = change.newValue;
            this.setState({
                test
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = change.newValue;
            this.setState({
                well
            });
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test: any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private handleEmailRadioChange = (index: number) => () => {
        const internalEmail = this.state.test.internalEmails[index];
        internalEmail.emailDefaultOn = !internalEmail.emailDefaultOn;
    }

    public renderEmailMudReportRadio = (internalEmail: IWellTestGroupEmail, index: number) => () => {
        return (
            <div>
                <FormGroup check={true} inline={true}>
                    <Input
                        name={"emailMudReport" + index}
                        id={"emailMudReport" + index}
                        type="radio"
                        value="true"
                        onChange={this.handleEmailRadioChange(index)}
                        checked={this.state.test.internalEmails[index].emailDefaultOn}
                    />
                    <Label style={{marginLeft: '0.25rem'}}check={true}>
                        Yes
                    </Label>
                </FormGroup>
                <FormGroup check={true} inline={true}>
                    <Input
                        name={"emailMudReport" + index}
                        id={"emailMudReport" + index}
                        type="radio"
                        value="false"
                        onChange={this.handleEmailRadioChange(index)}
                        checked={!this.state.test.internalEmails[index].emailDefaultOn}
                    />
                    <Label style={{marginLeft: '0.25rem'}}check={true}>
                        No
                    </Label>
                </FormGroup>
            </div>
        );
    }

    private formatInternalGroupEmails = () => {
        const internalEmails = this.state.test.internalEmails;
        const headers = [
            "Email",
            "Type",
            "Description",
            "Email Mud Report"
        ];
        const rows = [] as any[];
        internalEmails.forEach((ge, index) => {
            const tempRow = [
                {
                    content: ge.email
                },
                {
                    content: "Internal"
                },
                {
                    content: ge.description,
                },
                {
                    content: this.renderEmailMudReportRadio(ge, index),
                    sortItem: ge.emailDefaultOn,
                    type: 'render'
                }
            ];

            rows.push(tempRow);
        });

        return { headers, rows };
    }

    private formatGroupEmails = () => {
        const operator = this.state.well.operator;
        const contractor = this.state.well.contractor;
        const headers = [
            "Email",
            "Type",
            "Description",
        ];
        const rows = [] as any[];
        operator.groupEmails.forEach(ge => {
            const tempRow = [
                {
                    content: ge.email
                },
                {
                    content: "Operator"
                },
                {
                    content: ge.description,
                }
            ];

            rows.push(tempRow);
        });

        contractor.groupEmails.forEach(ge => {
            const tempRow = [
                {
                    content: ge.email
                },
                {
                    content: "Contractor"
                },
                {
                    content: ge.description
                }
            ];

            rows.push(tempRow);
        });

        return { headers, rows };
    }

    public handleChange(test: ITest) {
        this.setState({
            isDirty: true,
            test
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;

        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/welldata/testsetup');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/holegeometry/bitdata');
        }
    }

    public render() {
        return(
            <div className="ManageContacts">
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Internal Distribution Emails</h4>
                        <DataTable
                            list={this.formatInternalGroupEmails()}
                        />
                    </Col>
                    <Col md="12">
                        <h4 className="table-h4">External Distribution Emails</h4>
                        <DataTable
                            list={this.formatGroupEmails()}
                        />
                    </Col>
                    <Col md="12">
                        <OperatorContacts test={this.state.test} operators={this.state.test.operatorContacts} handleChange={this.handleChange} />
                    </Col>
                    <Col md="12">
                        <ContractorContacts test={this.state.test} contractors={this.state.test.contractorContacts} handleChange={this.handleChange} />
                    </Col>
                    <Col md="12">
                        <OtherContacts test={this.state.test} contacts={this.state.test.otherContacts} handleChange={this.handleChange} />
                    </Col>
                </Row>
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
            </div>
        );
    }
}

export default withRouter(ManageContacts);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/WellData/ManageContacts/ManageContacts.tsx